<template>
    <div>
        <!-- Tabs中包含table时,不嵌套row,col会引起table在渲染时缓慢滚动宽度 -->
        <div class="main_title">
        	<div class="box1"><div class="vline"></div>{{title1}}，您好，为您匹配到以下优惠政策</div>
        	<div class="box2"> <Button type="primary" id="btn11" @click="reMatch">重新匹配</Button></div>
        </div>
        <div class="rowBox">
        	<div class="box">
            	<div :style="{display:isshowicon?'flex':'none'}" class="lefticon"><img src="../../../assets/images/taxmatch/c3.png" /></div>
	            <div class="rightinfo">
	                <div class="row1">税收优惠行业-通用规定</div>
	                <div class="row2">{{total_common}}<span class="txtSuffix">条</span></div>
	                <div class="row3">
	                    <span>法规层级：</span>
	                    <span><Tag :color="thems[0]">中央</Tag></span>
	                </div>
            	</div>
            </div>
            <div class="box">
            	<div :style="{display:isshowicon?'flex':'none'}" class="lefticon"><img src="../../../assets/images/taxmatch/c2.png" /></div>
	            	<div class="rightinfo">
	                <div class="row1">税收优惠行业专属规定-{{industry_item_label}}</div>
	                <div class="row2">{{total_special}}<span class="txtSuffix">条</span></div>
	                <div class="row3">
	                    <span>法规层级：</span>
	                     <span><Tag :color="thems[0]">中央</Tag>
	                    <Tag v-for="item,index in locationData" :color="thems[index+1]" :key="item.id">{{item.label}}</Tag></span>
	                </div>
            	</div>
            </div>
            <div class="box">
                <div :style="{display:isshowicon?'flex':'none'}" class="lefticon"><img src="../../../assets/images/taxmatch/c1.png" /></div>
                <div class="rightinfo">
                    <div class="row1">税收优惠项目-{{tax_item_label}}</div>
                    <div class="row2">{{total_taxitem}}<span class="txtSuffix">条</span></div>
                    <div class="row3">
                        <span>法规层级：</span>
                        <span><Tag :color="thems[0]">中央</Tag>
                        <Tag v-for="item,index in locationData" :color="thems[index+1]" :key="item.id">{{item.label}}</Tag></span>
                    </div>
                </div>
            </div>
        </div>
        <Row>
            <Col span="24" style="background: white;padding: 5px;">
            <Tabs :animated="false" size="small" name="1">
            	<TabPane :label="labletxt3" tab="1">
                    <MyPushTable ref="mycommonpushlist" @changepage="cloudChangePage"></MyPushTable>
                </TabPane>
                <TabPane :label="labletxt2" tab="1">
                    <MyPushTable ref="myspecialpushlist" @changepage="cloudChangePage"></MyPushTable>
                </TabPane>
                <TabPane :label="labletxt0" tab="1">
                    <MyPushTable ref="mylastpushlist" @changepage="cloudChangePage"></MyPushTable>
                </TabPane>
                <!-- <TabPane :label="labletxt2" tab="1">
                    <div class="childtabs">
                        <Tabs type="card" :animated="false" name="2">
                        	<TabPane :label="labletxt3" tab="2" name='name1'>
                              
                            </TabPane>
                            <TabPane label="通用规定" tab="2" name='name2'>
                              
                            </TabPane>
                        </Tabs>
                    </div>
                </TabPane> -->
            </Tabs>
            </Col>
        </Row>
        <br />
    </div>
</template>
<script>
import AssistantTable2 from './tax_incentives_table.vue'
import assistantData from '../../../assets/json/assistantTable.json'
import assistantWorkTable from '../../../assets/json/assistantWorkTable.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import store from '../../../store'
import constJson from '../../../api/common/constjson.js'
var constJ = new constJson()
export default {
    name: 'Assistant_Cloud_Notice',
    data() {
        return {
            thems:['magenta','cyan','orange'],
        	isshowicon:true,
            title1: "",
            mobile: '',
            PageIndex: 1,
            PageSize: 10,
            tabIndex: 0, //1=项目,2=行业
            defaultpc: {
                p: "510100",
                c: "000000",
            },
            tagpc: {
                general: [{
                    p: "000000",
                    c: "000000",
                }],
                common: [],
                special: [],
            },
            isFirstSearch: false,
            isFilter: true,
            classid: '',
            scencs: '',
            fileheader: [{
                    "title": "文件名",
                    "key": "filename",
                },
                {
                    "title": "文件效力",
                    "key": "potence",
                },
                {
                    "title": "成文时间",
                    "key": "pdate",
                },
                {
                    "title": "（制定）发文单位",
                    "key": "publisher",
                },
            ],
            industry_code: '',
            item_code: '',
            common_code: "000002000004000001",
            tax_item_label: '',
            industry_item_label: '',
            total_taxitem: 0,
            total_common: 0,
            total_special: 0,
            locationData: [], //地理信息显示
            labletxt0: (h) => {
                return h('div', [
                    h('span', { style: { fontSize: '16px' } }, '税收优惠项目'),
                    h('span', {
                        style: {
                            color: 'red',
                        }
                    }, ' (' + this.tax_item_label + ')'),
                ])
            },
            labletxt1: (h) => {
                return h('div', [
                    h('span', {
                        style: {
                            color: '#2d8cf0',
                        }
                    }, this.tax_item_label),
                ])
            },
            labletxt2: (h) => {
                return h('div', [
                    h('span', { style: { fontSize: '16px' } }, '税收优惠行业专属规定'),
                    h('span', {
                        style: {
                            color: 'red',
                        }
                    }, ' (' + this.industry_item_label + ')'),
                ])
            },
            labletxt3: (h) => {
                return h('div', [
                    h('span', { style: { fontSize: '16px' } }, '税收优惠行业'),
                    h('span', {
                        style: {
                            color: 'red',
                        }
                    }, ' (通用规定)'),
                ])
            }

        }
    },
    computed: {
        ...mapGetters(['sliderLength', 'getUserId', 'sta']),
    },
    components: {
        'MyPushTable': AssistantTable2
    },
    created: function() {
        console.log('result created==>')
    },
    provide() {
        return {}
    },
    methods: {
    	reMatch(){
    		console.log('重新匹配')
    		this.$emit('rematch')
    	},
        showResult(value) {
            console.log('show result of match file==>')
            console.log(value)
            if (value) {
                if (value.location_item.length == 1) {
                    //省级
                    let province = {
                        p: value.location_item[0].value,
                        c: '000000'
                    }
                    this.tagpc.general.push(province)
                } else if (value.location_item.length == 2) {
                    //省级
                    let province = {
                        p: value.location_item[0].value,
                        c: '000000'
                    }
                    let city = {
                        p: value.location_item[0].value,
                        c: value.location_item[1].value,
                    }
                    this.tagpc.general.push(province)
                    this.tagpc.general.push(city)
                } else {
                    console.log('获取地域信息异常')
                }
            }
            // this.classid = value.industrycode
            this.industry_code = value.industrycode
            this.item_code = value.itemcode
            this.tax_item_label = value.tax_selected_item.label
            this.industry_item_label = value.industr_selected_item.label
            this.title1 = value.unitname
            this.mobile = value.unittel
            //用于显示的地域信息
            this.locationData = value.location_item
            this.getLastPushList(1, this.$Tools.fileMatchScene().TAX_ITEM)
            this.getLastPushList(1, this.$Tools.fileMatchScene().COMMON)
            this.getLastPushList(1, this.$Tools.fileMatchScene().SPECIAL)
            // if (store.state.user.accounttype !== 0) {
            //     this.getLastPushList(1, this.$Tools.fileMatchScene().TAX_ITEM)
            //     this.getLastPushList(1, this.$Tools.fileMatchScene().COMMON)
            //     this.getLastPushList(1, this.$Tools.fileMatchScene().SPECIAL)
            // } else {
            //     //重登录
            //     console.log('政策匹配用户未登录==>')
            // }

        },
        getLastPushList(index, sence) {
            let currentIndex = index
            var item = {}
            item.text = ""
            item.stime = ""
            item.etime = ""
            item.potence = ""
            item.tagid = "" //"000002000001"
            item.text2 = ""
            item.ps = this.defaultpc
            item.tagpc = this.tagpc
            item.fs = this.isFirstSearch
            item.ft = this.isFilter
            item.id = sence == this.$Tools.fileMatchScene().TAX_ITEM ? this.item_code : (sence == this.$Tools.fileMatchScene().COMMON ? this.common_code : this.industry_code) //"000002000001000001" //this.classid
            item.scencs = "" //从冒泡参数中取得当前的场景状态
            item.company = this.title1
            item.mobile = this.mobile
            console.log(item)
            constJ.reqGetGeneralFilesMatch(this.PageSize, currentIndex, item, true).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                    	this.$emit('update-progress')
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.fileheader,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                warninglevel: res.tbls[0].warninglevel,
                                warningtext:res.tbls[0].warningtext,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.fileheader,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                warninglevel: 0,
                                warningtext:'',
                                tabname: "newfiles",
                            }
                        }
                    } else {
                    	
                    }
                } else {
                	this.$Message.error(res.rtndesc)
                	// this.$emit('update-progress')
                   	return
                }
                if (sence == this.$Tools.pushScene().TAX_ITEM) {
                    this.$refs.mylastpushlist.show(obj, sence)
                    this.total_taxitem = obj.total
                } else if (sence == this.$Tools.pushScene().COMMON) {
                    this.$refs.mycommonpushlist.show(obj, sence)
                    this.total_common = obj.total
                } else if (sence == this.$Tools.pushScene().SPECIAL) {
                    this.$refs.myspecialpushlist.show(obj, sence)
                    this.total_special = obj.total
                }

            })
        },
        reload() {
            this.getLastPushList(1, this.$Tools.fileMatchScene().TAX_ITEM)
            this.getLastPushList(1, this.$Tools.fileMatchScene().COMMON)
            this.getLastPushList(1, this.$Tools.fileMatchScene().SPECIAL)
            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        cloudChangePage(index, type) {
            console.log('index=' + index, 'type=' + type)
            if (type === this.$Tools.fileMatchScene().COMMON) {
                this.getLastPushList(index, this.$Tools.fileMatchScene().COMMON)
            } else if (type === this.$Tools.fileMatchScene().TAX_ITEM) {
                this.getLastPushList(index, this.$Tools.fileMatchScene().TAX_ITEM)
            } else if (type === this.$Tools.fileMatchScene().SPECIAL) {
                this.getLastPushList(index, this.$Tools.fileMatchScene().SPECIAL)
            }
        },

    },
    watch: {
        sliderLength: function(v) {
        	if(v>1){
        		this.isshowicon=false
        	}else{
        		this.isshowicon=true
        	}
        }
    },

}
</script>
<style lang="less" scoped>
.popalert {
    background: #fff;
    width: 100%;
    padding-bottom: 10px;
    margin: 0 auto;
}

.popalert/deep/.ivu-icon {
    position: relative;
    top: 5px
}

.popalert/deep/.ivu-alert-close {
    top: 4px
}

.popalert/deep/.ivu-alert {
    margin-bottom: 0px;
}


.childtabs {
    /deep/ .ivu-tabs.ivu-tabs-card>.ivu-tabs-bar .ivu-tabs-tab-active {
        height: 32px;
        padding-bottom: 5px;
        background: #2d8cf0;
        transform: translateZ(0);
        border-color: #dcdee2;
        // color: white;
    }

}

.main_title {
	display: flex;
	flex-direction: row;
    height: 20px;
    font-size: 18px;
	font-family: Microsoft YaHei;
	font-weight: bold;
	margin-top: 10px;
	margin-bottom: 20px;
	flex:5;
    .box1{
	    display: flex;
	    align-items: center;
        justify-content: flex-start;
        flex:4;
        .vline{
        	width: 4px;
        	height: 18px;
        	border: 4px solid #FE6F37;
        	border-radius:5px;
        	margin-right: 10px;
        }
    }
    .box2{
    	display: flex;
    	flex:1;
    	align-items: center;
        justify-content: flex-end;

    }
    #btn11 {
        	background:#FE6F37;
        	border-radius: 0px;
        	border:none;
        	box-shadow: none;
    }
    #btn11:hover {
        	background:#f24000;
        	border-radius: 0px;
        	border:none;
        	box-shadow: none;
    }
}

.rowBox {
    display: flex;
    width: 100%;
    background-color: #F5F7F9;
    flex-direction: row;
    margin-bottom: 20px;
    box-shadow: 0px 1px 5px 1px #e8eaec;
    .box {
        display: flex;
        flex-direction: row;
  		flex:1;
        .lefticon{
        	display: flex;
        	flex:1;
        	align-items: center;
            justify-content: center;
            background: white;
        }
        .rightinfo{
        	padding-left:5px;
        	flex:4;
        	display: flex;
        	height: 130px;
	        background: white;
	        flex-direction: column;
	        border-right: 1px solid #e8eaec;
        	.row1 {
	            display: flex;
	            flex: 2;
	            align-items: flex-end;
	            justify-content: left;
	            font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #000000;
	            //background:green;
        	}

        	.row2 {
	            display: flex;
	            flex: 3;
	            align-items: center;
	            justify-content: left;
	            font-size: 28px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #2D2F33;
	            .txtSuffix {
	                font-size: 16px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #677380;
	                margin-left: 10px;
	            }
	            //background: blue;
        	}
        	.row3 {
	            display: flex;
	            flex: 2;
	            align-items: top;
	            justify-content: flex-start;
	            span{
	            	min-width:70px;
	            	display: flex;
	            	align-items: top;
	            	line-height: 27px;
	            	font-size: 14px;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #000000;

	            }
	            //background: yellow;
        	}
        }

        
    }

}
</style>